import InstructionsWrapper from '@cohort/components-xps/components/apps/InstructionsWrapper';
import DefaultInstructions from '@cohort/components-xps/components/apps/tiktok/triggers/DefaultInstructions';
import i18nComponentsXpsInstance from '@cohort/components-xps/lib/i18n';
import type {TikTokKeywordInDescriptionTriggerStruct} from '@cohort/shared/apps/tiktok/triggers/keywordInDescription';
import type {InstructionsComponentProps} from '@cohort/shared/apps/trigger';
import {Fragment} from 'react';
import {getI18n, useTranslation} from 'react-i18next';

const TiktokKeywordInDescriptionTriggerIntegrationInstructionsComponent: React.FC<
  InstructionsComponentProps<TikTokKeywordInDescriptionTriggerStruct>
> = ({connected, config, selectedLanguage}) => {
  const {t} = useTranslation('components', {
    keyPrefix: 'apps.tiktok.triggers.keyword-in-description',
    lng: selectedLanguage ?? getI18n().language,
    i18n: i18nComponentsXpsInstance,
  });

  return (
    <InstructionsWrapper>
      <ul className="mt-2 list-disc pl-6">
        {connected ? (
          <Fragment>
            <li>
              <p>{t('instructionsStep1', {keyword: config.keyword})}</p>
            </li>
            <li>
              <p>{t('instructionsStep2')}</p>
            </li>
            <li>
              <p>{t('instructionsStep3')}</p>
            </li>
          </Fragment>
        ) : (
          <DefaultInstructions />
        )}
      </ul>
    </InstructionsWrapper>
  );
};

export default TiktokKeywordInDescriptionTriggerIntegrationInstructionsComponent;
